import { render, staticRenderFns } from "./WelcomeScreenElements.vue?vue&type=template&id=999d46de&scoped=true&"
import script from "./WelcomeScreenElements.vue?vue&type=script&lang=ts&"
export * from "./WelcomeScreenElements.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeScreenElements.vue?vue&type=style&index=0&id=999d46de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999d46de",
  null
  
)

export default component.exports